module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.required && !_vm.field.hide
      }),
      expression: "{required: required && !field.hide}"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-as": _vm.field.description.replace(/\./g, ''),
      "id": _vm.field.name,
      "name": _vm.field.name,
      "disabled": _vm.locked
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": function($event) {
        return _vm.$emit('input', $event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Select option...")]), _vm._v(" "), _vm._l((_vm.field.values), function(option) {
    return (!_vm.isValueHidden(option.label)) ? _c('option', {
      key: option.name,
      domProps: {
        "value": option.label
      }
    }, [_vm._v("\n    " + _vm._s(option.label) + "\n  ")]) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-698c8cae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/render/DropdownRender.vue
// module id = 1682
// module chunks = 1